import * as Yup from "yup";

export const YupPayCondition = Yup.object().shape({
  eligibilityCompleted: Yup.boolean(),
  baselineCompleted: Yup.boolean(),
  therapyWeeksCompleted: Yup.array().of(Yup.boolean()),
  paymentFor: Yup.string().required('Required'),
  amount: Yup.number().required('Required'),
}).nullable(true).default(null)